import { get } from '@/services/index.js';

/**
 * Resolves the promo code a search can keep: an empty string when the merchant
 * does not recognise it. A failed lookup keeps the code, so a network error never
 * silently drops a valid promo.
 * @param {string} merchantId - merchant the promo code belongs to
 * @param {string} promoCode - code taken from the current search filter
 * @returns {Promise<string>} the code itself, or '' when it is invalid
 */
export function resolveUsablePromoCode(merchantId, promoCode) {
  if (!promoCode) return Promise.resolve('');

  return get('CORE_HOTEL', 'promocode-detail', { merchant_id: merchantId, promo_code: promoCode })
    .then((response) => (response.data && response.data.success ? promoCode : ''))
    .catch(() => promoCode);
}



// WEBPACK FOOTER //
// ./src/utils/bePromoCode.js